export const locations = {
  seo: {
    title: '店舗情報 | LensBank プロ機材レンタル',
    description: '台北、台中、台南に8つのサービス拠点、便利な機材レンタルサービスを提供。店舗住所、営業時間、連絡先、交通情報をご確認ください。',
    keywords: '店舗情報,機材レンタル場所,台北店舗,台中店舗,台南店舗,倉庫'
  },
  hero: {
    title: '店舗情報',
    subtitle: '{{count}}つのサービス拠点、便利な機材レンタルサービス'
  },
  types: {
    all: 'すべて',
    store: '店舗',
    warehouse: '倉庫'
  },
  card: {
    store: '店舗',
    warehouse: '倉庫',
    hours: '営業時間',
    phone: '電話',
    address: '住所',
    viewDetails: '詳細を見る',
    getDirections: 'ルートを取得'
  },
  detail: {
    overview: '拠点情報',
    hours: '営業時間',
    contact: '連絡先',
    phone: '電話',
    email: 'メール',
    address: '住所',
    transportation: '交通手段',
    services: '提供サービス',
    equipmentRental: '機材レンタル',
    consultation: '専門コンサルティング',
    technicalSupport: '技術サポート',
    pickup: '機材受取',
    return: '機材返却',
    map: '地図',
    nearbyStores: '近くの拠点'
  },
  hours: {
    monday: '月曜日',
    tuesday: '火曜日',
    wednesday: '水曜日',
    thursday: '木曜日',
    friday: '金曜日',
    saturday: '土曜日',
    sunday: '日曜日',
    closed: '定休日'
  }
};